import React from "react";
import styles from "../styles/Thank-you.module.css";

interface PricingCardProps {
  title: string;
  badge: string;
  subtitle?: string;
  price?: string;
  originalPrice?: string;
  savings?: string;
  ctaText: string;
  features: string[];
  special?: boolean;
}

const RegularPricingCard: React.FC<PricingCardProps> = ({
  title,
  badge,
  subtitle,
  price,
  originalPrice,
  savings,
  ctaText,
  features,
}) => {
  const handleCtaClick = () => {
    window.location.href = process.env.REACT_APP_TALLY_FORM_URL;
  };

  return (
    <div className={styles.pricingColumn}>
      <div className={styles.pricingCard}>
        <div className={styles.pricingHeader}>
          <div className={styles.pricingTitle}>{title}</div>
          <div className={styles.pricingBadge}>{badge}</div>
        </div>
        {subtitle && <div className={styles.pricingSubtitle}>{subtitle}</div>}
        {price && (
          <div className={styles.pricingPrice}>
            <div className={styles.currentPrice}>{price}</div>
            <div className={styles.originalPrice}>
              <div>{originalPrice}</div>
              <div>{savings}</div>
            </div>
          </div>
        )}
        <div className={styles.pricingFeatures}>
          <div className={styles.pricingCta}>
            <button className={styles.pricingCtaButton} onClick={handleCtaClick}>
              {ctaText}
            </button>
          </div>
          <div className={styles.pricingFeaturesTitle}>Features</div>
          {features.map((feature, index) => (
            <div key={index} className={styles.featureItem}>
              <div className={styles.featureIcon}>
                <svg
                  width="100"
                  height="100"
                  viewBox="0 0 100 100"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="50" cy="50" r="50" fill="#F9A825" />
                  <path
                    d="M35 50L45 60L65 40"
                    stroke="white"
                    strokeWidth="8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className={styles.featureText}>{feature}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const SpecialPricingCard: React.FC<PricingCardProps> = ({
  title,
  badge,
  subtitle,
  price,
  originalPrice,
  savings,
  ctaText,
  features,
}) => {
  const handleCtaClick = () => {
    window.location.href = process.env.REACT_APP_STRIPE_CHECKOUT_URL;
  };

  return (
    <div className={styles.specialCardColumn}>
      <div className={styles.specialCard}>
        <div className={styles.specialPricingHeader}>
          <div className={styles.specialPricingTitle}>{title}</div>
          <div className={styles.specialPricingBadge}>{badge}</div>
        </div>
        {subtitle && <div className={styles.specialPricingSubtitle}>{subtitle}</div>}
        {price && (
          <div className={styles.specialPricingPrice}>
            <div className={styles.specialCurrentPrice}>{price}</div>
            <div className={styles.specialOriginalPrice}>
              <div>{originalPrice}</div>
              <div>{savings}</div>
            </div>
          </div>
        )}
        <div className={styles.specialPricingFeatures}>
          <div className={styles.specialPricingCta}>
            <button className={styles.specialPricingCtaButton} onClick={handleCtaClick} data-text={ctaText}>
              <span className={styles.specialPricingCtaButtonText}>{ctaText}</span>
            </button>
          </div>
          <div className={styles.specialPricingFeaturesTitle}>Features</div>
          {features.map((feature, index) => (
            <div key={index} className={styles.specialFeatureItem}>
              <div className={styles.specialFeatureIcon}>
                <svg
                  width="100"
                  height="100"
                  viewBox="0 0 100 100"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="50" cy="50" r="50" fill="#FFF" />
                  <path
                    d="M35 50L45 60L65 40"
                    stroke="orange"
                    strokeWidth="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className={styles.specialFeatureText}>{feature}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const PricingCard: React.FC<PricingCardProps> = (props) => {
  return props.special ? <SpecialPricingCard {...props} /> : <RegularPricingCard {...props} />;
};

export default PricingCard;
